export const mints = [
  'FtUUEcRQQ8vzPtzddDKwg92WeavgzGmv86hor5sMXdTx',
  '8EZEZAEBLhN94bkBxAx6i5P4xqGTBrptLr3dGWysT2kA',
  'Hv8iXjq376tLt5g73m6cpdNJSocvedusbTdKyCJzYJ9s',
  'BWm9oMX7Vi5ZhRzB3oHHzoRUaw9Hn4i1gHzexW6JYswm',
  'AZwCmyDzjSaiQ7TvKFs4xAUyzcwomHLBQbzj3w6aDru',
  'p7TSFbGHEmyUhzAHmZKwyyiyR1w7S68ViLWvurfArz6',
  'HMwgKKSD44BrhoV4LeQCs3qqt1dkcZMHyU6rREmzhx2F',
  'B2QKrka9zhGEJQjnhnvnNYxbirJpTSxu2LgRZ4NzXZ8X',
  '6B3GoKqdz1dFuL8owayemb77C2nDuAcitTnnQhqmzb9F',
  'M2eHCe5YQxhA1JfcfkM6KP1SNZ4qNRk5U9zCcfXizL7',
  '62UYSafcJk8ZancdE3ae2C2nk78YZrRMYBocKfyCaj7T',
  '6XDypn19nadPgq4LjyHykVMUc8T31wpSKuQMnXa8Tq2j',
  'C6wEdp3xPGrGs8LJeVL3ApRbVX63ZuawGnu3XRNBTFz9',
  '4xgY8Q3NT9J7V33pDvEXX6WC2jm7ypyfXzqNxiJSS26F',
  'BYPCTYxFJBoYwL3DHJq5DcqW7EXJB6BSa9ks5WYXph6L',
  '6GLgjLaznv6wFnA7X4UwBszDkn6NUvAgpt9p3CVeXsAy',
  'C6QtUNyKxknBH48NXoqzrGrerdX3t68ENokacF8BY1zX',
  'FBP7JFmpD9DBtGsyJDc7sLH87cusixKZKirA75NBHzz8',
  'HhYSj7dovsVgRvPuoCVRu5yQ6zE32kxTSQy8VAH2RJVE',
  '4N73TGe9WrfwKGgNajiPxpyH1jH7gjj4ZXwKdXuLruhF',
  'Frfx3xbXEjWxidEDaofNRmVyf4in1FZMNu4PaqYApGRv',
  'HkSPHjMzKnUxSNTKK1M4TBFKxX42JQyZXyF8b8yaGLfM',
  '8TLjXWTwQT7wv1V8ZvMLtgJdeuuMpQgWw3zq23gEKSoh',
  'DKyev3rLARZGR6t6QZUrWQkyJ48YSoffmghhcUUzoy6M',
  'ByPCTtYt8KLXmHnmV8Suh2vqvjhorettTXE9ietSJiMP',
  'FPRpvRV6vaG5w5LbqsmmWYrgPdJfhFZnoSe1uZYpjv3o',
  '9QoaYHiknHBGsXco7YKPiaA7jJeyvrwcVQneHqmup1DV',
  '4rjqghKsP43dYZX5HeTWwcSQUGMrZwygMrZxyPNj8Gzi',
  'bzghKyem8zu5pmXrnnvqDKbzY8DVNw7P5ZkLGTrwu3p',
  '4WBLJPUDecpVNSCAyXPU35FrSJnk5X389JeCEYEneqib',
  'F3YTmvZqWnnTZ6bcpt6sSJ1s1karueCToz2994VbeGPi',
];
